export const Favorites = () => {
  return <div>Favorites</div>;
};
